
<div class="modal-dialog confirm-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">{{title}}</h5>
      <button class="close" type="button" (click)="cancel()">&times;</button>
    </div>
    <div class="modal-body">{{message}}</div>
    <div class="modal-footer">
      <button class="btn btn-primary" type="button" (click)="ok()">OK</button>
      <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>